import { render, staticRenderFns } from "./PeriodeRpl.vue?vue&type=template&id=2c5ade6c&scoped=true&"
import script from "./PeriodeRpl.vue?vue&type=script&lang=js&"
export * from "./PeriodeRpl.vue?vue&type=script&lang=js&"
import style0 from "./PeriodeRpl.vue?vue&type=style&index=0&id=2c5ade6c&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ade6c",
  null
  
)

export default component.exports